import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mg-toggle-menu',
  templateUrl: './toggle-menu.component.html',
  styleUrls: ['./toggle-menu.component.scss'],
})
export class ToggleMenuComponent implements OnInit, OnDestroy {
  @Input() showMenu = false;
  @Input() activateAnimation = true;
  @Output() showMenuStatus = new EventEmitter<boolean>();
  subscriptionToggle!: Subscription;
  constructor() {}

  ngOnInit(): void {}

  toggleMenu() {
    this.showMenu = !this.showMenu;
    this.showMenuStatus.emit(this.showMenu);
  }

  ngOnDestroy(): void {
    this.subscriptionToggle?.unsubscribe();
  }
}
